import {InputAdornment, OutlinedInputProps, TextField, TextFieldProps, TextFieldVariants} from "@mui/material";
import PermIdentityIcon from "@mui/icons-material/PermIdentity";
import {useTheme} from "../../../contexts/theme";
import React from "react";
import {Simulate} from "react-dom/test-utils";
import error = Simulate.error;

interface TextinputField {
    name: string;
    id?: string | "filled-hidden-label-small" | "outlined-basic";
    placeholder: string;
    type: string;
    value?: string;
    onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
    inputProps?: OutlinedInputProps;
    marginLeft?: string;
    marginRight?: string;
    marginBottom?: string;
    marginTop?: string;
    backgroundColor?: string;
    fontSize?: string;
    borderBottomColor?: string;
    borderColor?: string;
    variant: TextFieldVariants;
    borderRadius?: string;
    color?: string;
    label?: string;
    size?:  "small" | "medium" ;
    disabled?: boolean;
    border?: string
    width?: string
    height?: string
    required?: boolean;
    readOnly?: boolean;
    fullWidth?: boolean;
    onBlur?: (e: React.FocusEvent<HTMLInputElement>) => void;
    error?: boolean;
    helperText?: string;
    onKeyDown?: (e: React.KeyboardEvent<HTMLInputElement>) => void;
    inputRef?: React.Ref<any> | undefined
}

function TextinputField ({
                             name,
                                id,
                             placeholder,
                             type,
                             value,
                             onChange,
                             inputProps,
                            backgroundColor,
                            fontSize,
                            borderBottomColor,
                            borderColor,
                            marginBottom,
                            marginTop,
                            marginLeft,
                            marginRight,
                            variant,
                            borderRadius,
                            color,
                            label,
                            size = "small",
                            border,
                            disabled,
                            width,
                             height,
                             onKeyDown,
                             inputRef,
                            readOnly= false,
                            required = false,
                            fullWidth = false,
                             onBlur = (e) => {},
                             helperText,
                             error
                         }: TextinputField) {

    const theme = useTheme();

    return (

        <TextField
            name={name}
            type={type}
            hiddenLabel
            fullWidth={fullWidth}
            id={id}
            variant={variant}
            size={size}
            placeholder={placeholder}
            value={value}
            onChange={onChange}
            onBlur={onBlur}
            onKeyDown={onKeyDown}
            label={label}
            InputProps={{...inputProps, readOnly: readOnly}}
            disabled={disabled}
            required={required}
            helperText={helperText}
            error={error}
            inputRef={inputRef}
            sx={{
                width: width ? width : undefined,
                backgroundColor: {backgroundColor},
                marginLeft: {marginLeft},
                marginRight: {marginRight},
                marginTop: {marginTop},
                marginBottom: {marginBottom},
                borderRadius: {borderRadius},
                "& .MuiOutlinedInput-root.Mui-disabled": {
                    "& fieldset": {
                        borderColor: theme.palette.lightGrey, // Colore del bordo

                    },
                },
                '& .MuiInputBase-input': {
                    height: height ? height : undefined,
                    fontSize: {fontSize},  // Font-size dell'input
                },
                '& .MuiInputLabel-root': {
                    fontSize: {fontSize}, // Font-size dell'etichetta
                    color: {color},

                    '&.Mui-focused': { // Colore della label in focus
                        color: theme.palette.orange,
                    },

                },
                '& .MuiInputLabel-root.Mui-disabled': {
                    color: theme.palette.lightGrey,
                    opacity: 0.5,
                },
                '& .MuiFilledInput-root::after': {
                    borderBottom: {borderBottomColor}, // Cambia il colore della linea
                },
                '&:focus .MuiFilledInput-root::after': {
                    borderBottom: '{borderBottomColor}', // Colore in focus
                },
                '& .MuiOutlinedInput-notchedOutline':{
                    borderColor: {borderColor},
                    borderRadius: {borderRadius},
                    border: border ? border : undefined
                },
                "& .MuiOutlinedInput-root": {
                    '&:hover fieldset': { // Colore del bordo in hover
                        borderColor: theme.palette.orange,
                    },
                    '&.Mui-focused fieldset': { // Colore del bordo in focus
                        borderColor: theme.palette.orange,
                    },
                },
                '& .MuiOutlinedInput-input':{
                    color: {color},
                    '&.Mui-disabled': {
                        opacity: 0.5,
                        color: theme.palette.lightGrey,
                        '-webkit-text-fill-color': theme.palette.lightGrey,

                    }
                }

            }}/>

    );

}

export default TextinputField;